const useProgramContext = () => {
  const { programId, lessonId, unitId, classroomId } = $('#slug-attributes').data() ?? {};

  return { programId, lessonId, unitId, classroomId };
};

export default useProgramContext;
